import { Icon, IconName } from '@economic/taco';
import React from 'react';
import cn from 'classnames';

interface ListElement {
    text: string;
    color?: string;
    iconName?: IconName;
    className?: string;
}
interface Props {
    className?: string;
    listElementsClassName?: string;
    elements: ListElement[];
}
export default function StyledList({ className, elements, listElementsClassName }: Props) {
    const getInfoListElement = (index: number, element: ListElement, isLastElement: boolean) => {
        return (
            <li key={index} className={cn(!isLastElement && 'pb-3', listElementsClassName)}>
                <div className="flex">
                    <Icon
                        className={cn('mr-2', element.className || '')}
                        color={element.color}
                        name={element.iconName ? element.iconName : 'circle-tick'}
                    />
                    {element.text}
                </div>
            </li>
        );
    };

    return (
        <ul className={cn('p-4', className)}>
            {elements.map((el, index) => getInfoListElement(index, el, elements.length === index + 1))}
        </ul>
    );
}
